import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleDown } from 'react-icons/fa';
import SystemsData from '../../data/systems/SystemsData.json';

const Nav = () => {
  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        <li>
          <Link to={process.env.PUBLIC_URL + '/'}>الرئيسية</Link>
        </li>

        <li>
          <Link to={process.env.PUBLIC_URL + '/about-us'}>عن الشركة</Link>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + '/download'}>التنزيلات</Link>
        </li>
        <li className="menu-item-has-children">
          <Link to="#" onClick={(e) => e.preventDefault()}>
            المنظومات <FaAngleDown />
          </Link>
          <ul className="axil-submenu">
            {SystemsData.map((system) => (
              <li key={system.slug}>
                <Link to={process.env.PUBLIC_URL + '/systems/' + system.slug}>
                  {system.title}
                </Link>
              </li>
            ))}
          </ul>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + '/courses'}>الدورات</Link>
        </li>

        {/* <li>
          <Link to={process.env.PUBLIC_URL + "/pricing-table"}>الاسعار</Link>
        </li> */}
        <li>
          <Link to={process.env.PUBLIC_URL + '/team'}>الفريق</Link>
        </li>

        <li>
          <Link to={process.env.PUBLIC_URL + '/contact'}>تواصل معنا</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
